"use strict";

var CompanySDK = require('@nackle/company-sdk');

var _require = require('../utils/endpoints'),
    companiesUrl = _require.companiesUrl;

var _require2 = require('../utils/error'),
    throwServiceError = _require2.throwServiceError;

var SERVICE_NAME = 'company';

module.exports = function (_ref) {
  var fetch = _ref.fetch,
      companyId = _ref.companyId;
  var sdk = new CompanySDK(companiesUrl, fetch);

  var getCompany = function getCompany() {
    return new Promise(function ($return, $error) {
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_1_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getCompany');
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(sdk.getCompany(companyId)).then($return, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };

  return {
    getCompany: getCompany
  };
};
//# sourceMappingURL=company.js.map